import { createFontSizeCSS } from '@hellodarwin/core/lib/theme/global-style';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
export const getMenuLinkTheme = (theme, app, isCurrent) => {
    switch (app) {
        case 'provider':
            return {
                color: isCurrent ? theme.colors.purple_3 : theme.colors.white_1,
                disabledColor: theme.colors.grey_4,
                disabledHoverColor: theme.colors.grey_4,
                hoverBackground: theme.colors.purple_2,
                hoverColor: theme.colors.white_1,
            };
        case 'admin':
            return {
                color: isCurrent ? theme.colors.purple_1 : theme.colors.grey_2,
                disabledColor: theme.colors.grey_3,
                disabledHoverColor: theme.colors.grey_3,
                hoverBackground: theme.colors.purple_4,
                hoverColor: theme.colors.purple_1,
            };
        default:
            return {
                color: isCurrent ? theme.colors.purple_2 : theme.colors.grey_2,
                disabledColor: theme.colors.grey_3,
                disabledHoverColor: theme.colors.grey_3,
                hoverBackground: theme.colors.purple_5,
                hoverColor: theme.colors.purple_1,
            };
    }
};
export const getMenuItemColorsStyling = (theme, isCurrent, app, disabled, noStyle) => {
    const navTheme = getMenuLinkTheme(theme, app, isCurrent);
    return css `
    cursor: pointer;
    color: ${disabled ? navTheme.disabledColor : navTheme.color};

    ${!noStyle &&
        `
  &:hover {
    background-color: ${navTheme.hoverBackground};
    color: ${disabled ? navTheme.disabledHoverColor : navTheme.hoverColor};
  }`}
  `;
};
export const MenuItemLabelContainer = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  position: relative;
  border-radius: ${({ theme }) => theme.border_radius.md};
  min-height: ${({ theme, $isSublink }) => $isSublink ? 0 : theme.spacing.xxl}px;
  padding: ${({ $isSublink, $noStyle, theme }) => $noStyle || $isSublink
    ? `${theme.spacing.xs}px ${theme.spacing.md}px`
    : `${theme.appearance.spacing * 1.5}px ${theme.appearance.spacing * 2}px`};
  margin-block: ${({ theme, $isSublink }) => $isSublink ? 2 : theme.appearance.spacing * 0.5}px;
  margin-inline-start: ${({ $isSectionItem, theme }) => $isSectionItem ? theme.spacing.md : 0}px;

  width: ${({ $isSectionItem, theme }) => $isSectionItem ? `calc(100% - ${theme.spacing.md}px)` : '100%'};

  ${({ theme, $isCurrent, $app, $noStyle, $pageAccessible }) => getMenuItemColorsStyling(theme, $isCurrent, $app, !$pageAccessible, $noStyle)}

  border-top: ${({ $withBorderTop, theme }) => $withBorderTop ? `1px solid ${theme.colors.grey_4}` : 'none'};

  svg {
    flex-shrink: 0;
    vertical-align: middle;
    display: block;
  }

  .ant-badge-count {
    font-size: ${({ theme }) => theme.fonts.body4};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    width: 100%;
  }
`;
const ParentLabelText = () => css `
  ${createFontSizeCSS('body3')}
  font-weight: 500;
`;
const SublinkText = () => css `
  ${createFontSizeCSS('body4')}
  font-weight: 400;
`;
export const MenuItemLabelText = styled.div `
  ${({ $isSublink }) => ($isSublink ? SublinkText() : ParentLabelText())}
`;
export const SubNavigationSectionLabel = styled.div `
  ${createFontSizeCSS('body4')}
  color: ${({ theme }) => theme.colors.grey_2};
  font-weight: 500;
  margin-block-start: ${({ $separated, theme }) => $separated ? theme.spacing.sm : 0}px;
  padding: ${({ theme }) => theme.spacing.xs}px
    ${({ theme }) => theme.spacing.md}px;
`;
export const SubitemsDropdownWrapperStyled = styled.div `
  display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
  position: absolute;
  top: ${({ $position }) => $position === 'bottom' ? 'calc(100% - 15px + 8px)' : '-15px'};
  left: ${({ $position }) => $position === 'bottom' ? '-45px' : 'calc(100% - 45px)'};
  width: max-content;
  padding: 15px 45px;
  z-index: 2000;
  min-width: calc(100% + 45px + 45px);
`;
export const SubitemsDropdownStyled = styled.div `
  padding: 0;
  padding-bottom: ${({ theme }) => theme.appearance.spacing * 2}px;
  position: relative;
  width: max-content;
  background-color: ${({ theme, $app }) => $app === 'provider' ? theme.colors.primary : theme.colors.white_1};
  border: 1px solid
    ${({ theme, $app }) => $app === 'provider' ? theme.colors.grey_4 : theme.colors.primary};
  ${MenuItemLabelContainer} {
    width: 100%;
  }
  .ant-badge {
    display: block;
    width: 100%;
  }
`;
export const NavigationTooltipTarget = styled.div `
  width: 100%;
`;
export const NavigationMenuItemStyled = styled.div `
  width: 100%;
  position: relative;
  z-index: 1200;
  .ReactCollapse--collapse {
    transition: height 300ms;
  }
`;
export const NavigationMenuItemWrapperStyling = (theme, _isCollapsed) => css `
  width: 100%;
  border: 0;
  padding: 0;
  background: ${theme.colors.transparent};
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: ${theme.border_radius.md};
  &:focus-visible {
    outline: 2px solid ${theme.colors.primary};
    outline-offset: 2px;
  }
  position: relative;
  z-index: 100;
`;
export const NavigationMenuItemWrapperStyled = styled.div `
  ${({ theme, $isCollapsed }) => NavigationMenuItemWrapperStyling(theme, $isCollapsed)}
`;
export const NavigationMenuItemWrapperAnchorStyled = styled.a `
  ${({ theme, $isCollapsed }) => NavigationMenuItemWrapperStyling(theme, $isCollapsed)}
`;
export const NavigationMenuItemWrapperLinkStyled = styled(Link) `
  ${({ theme, $isCollapsed }) => NavigationMenuItemWrapperStyling(theme, $isCollapsed)}
`;
export const MenuItemLabelCollapsedContent = styled.div `
  justify-content: center;
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xs}px;
  align-items: center;
`;
export const MenuItemLabelTextGroup = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ $gap }) => (typeof $gap === 'number' ? `${$gap}px` : $gap)};
  align-items: center;
`;
export const MenuItemLabelStatusGroup = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: fit-content;
  height: fit-content;
  line-height: 1;
`;
export const MenuItemAccessibleLabel = styled.span `
  position: absolute;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
`;
